<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-2"
      header="Anyag szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-card-body class="text-left">
        <div class="col-sm-">
          <div class="row-fluid">
            <!-- // FORM -->
            <b-form @submit="addElement">

              <div class="form-group">
                <label for="kategoria">Partner kategória</label>
                <b-form-select
                  size="sm"
                  v-model="list.kategoria"
                  :options="partnerkategoria"
                  class="form-control"
                  id="kategoria"
                  required
                ></b-form-select>
              </div>

              <div class="form-group">
                <label for="tipus">Anyag+kivitel (leghosszabb 36 karakter)</label>
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.tipus"
                  class="form-control"
                  id="tipus"
                  required
                />
              </div>

              <div class="form-group">
                <label for="megnevezes">Megnevezés ajánlatban (itt a leghosszabb szöveg 140! karakter)</label>
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.megnevezes"
                  class="form-control"
                  id="megnevezes"
                  required
                />
              </div>

              <template>
                <div>
                <label for="megnevezes">Leírás</label>
                  <b-form-textarea
                    size="sm"
                    id="leiras"
                    v-model="list.leiras"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>

              <div class="form-group">
                <label for="minimaldij">Minimum díj</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.minimaldij"
                  class="form-control"
                  id="minimaldij"
                  required
                />
              </div>

              <div class="form-group">
                <label for="ar1">0,124 alatt</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar1"
                  class="form-control"
                  id="ar1"
                />
              </div>

              <div class="form-group">
                <label for="ar2">0,125 - 0,249</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar2"
                  class="form-control"
                  id="ar2"
                />
              </div>

              <div class="form-group">
                <label for="ar3">0,250 - 0,499</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar3"
                  class="form-control"
                  id="ar3"
                />
              </div>

              <div class="form-group">
                <label for="ar4">0,500 - 0,749</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar4"
                  class="form-control"
                  id="ar4"
                />
              </div>

              <div class="form-group">
                <label for="ar5">0,750 - 0,999</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar5"
                  class="form-control"
                  id="ar5"
                />
              </div>

              <div class="form-group">
                <label for="ar6">1 - 2,499</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar6"
                  class="form-control"
                  id="ar6"
                />
              </div>

              <div class="form-group">
                <label for="ar7">2,5 - 4,999</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar7"
                  class="form-control"
                  id="ar7"
                />
              </div>

              <div class="form-group">
                <label for="ar8">5 - 9,999</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar8"
                 class="form-control"
                  id="ar8"
               />
              </div>

              <div class="form-group">
                <label for="ar9">10 - 19,999</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar9"
                 class="form-control"
                  id="ar9"
               />
              </div>

              <div class="form-group">
                <label for="ar11">20 fölött</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.ar10"
                  class="form-control"
                  id="ar11"
                />
              </div>

              <!-- // SAVE -->
              <b-button variant="primary" type="submit">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés
              </b-button>

              <!-- // CANCEL -->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="
                  $router.push({
                    name: 'Anyagtipusok'
                  })
                "
                ><b-icon-arrow-left></b-icon-arrow-left>
                Mégsem</b-button
              >
            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>

  </b-container>

</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: {
        minimaldij: 0,
        ar1: 0,
        ar2: 0,
        ar3: 0,
        ar4: 0,
        ar5: 0,
        ar6: 0,
        ar7: 0,
        ar8: 0,
        ar9: 0,
        ar10: 0
      },
      partnerkategoria: [
        'A1',
        'VEA',
        'BID',
        'TD',
        'K5',
        'K6',
        'K7',
        'K8',
        'K9',
        'K10'
      ]
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      payload.id = this.list.id
      payload.tipus = this.list.tipus
      payload.kategoria = this.list.kategoria
      payload.megnevezes = this.list.megnevezes
      payload.leiras = this.list.leiras
      payload.minimaldij = this.list.minimaldij
      payload.hidden = 1
      payload.ar1 = this.list.ar1
      payload.ar2 = this.list.ar2
      payload.ar3 = this.list.ar3
      payload.ar4 = this.list.ar4
      payload.ar5 = this.list.ar5
      payload.ar6 = this.list.ar6
      payload.ar7 = this.list.ar7
      payload.ar8 = this.list.ar8
      payload.ar9 = this.list.ar9
      payload.ar10 = this.list.ar10
      payload.token = this.token
      payload.userType = this.userType

  axios.post(process.env.ROOT_API+'/anyagtipus/save', {payload}).then((res) => {
        this.$router.push({name: 'Anyagtipusok'})
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    payload.id = id
    payload.token = this.token
    payload.userType = this.userType

    if (id) {
      axios.post(process.env.ROOT_API+'/anyagtipus/edit', {payload}).then((res) => {
        this.list = res.data
        // this.list.push(res.data)
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AnyagtipusokNew.vue